import { useState } from "react";
import { CustomPostAPI } from "../APIConnector";
import Swal from "sweetalert2";

export default function ClaimVenueModal({
  BtnText,
  VenueDetails,
  handlePopUp,
  isClaimClick,
  notInterested = false,
}) {
  const [formData, setFormData] = useState({
    VenueOwnerName: "",
    VenueOwnerEmail: "",
    VenueOwnerPhone: "",
    VenueOwnerReason: "1",
    VenueOwnerReasonText: "",
  });
  const [formError, setFormError] = useState({ errorId: 0, errorMsg: "" });
  const [formLoader, setFormLoader] = useState(false);

  const handlelength = (e) => {
    if (e.target.value.length > 10) {
      return;
    }
    setFormData({ ...formData, VenueOwnerPhone: e.target.value });
  };

  const sendDetails = async () => {
    if (formData.VenueOwnerName === "") {
      setFormError({
        ...formError,
        errorId: 1,
        errorMsg: "Please enter a valid name.",
      });
      setFormLoader(false);
      return;
    }
    if (formData.VenueOwnerPhone === "") {
      setFormError({
        ...formError,
        errorId: 2,
        errorMsg: "Please enter a valid Phone no.",
      });
      setFormLoader(false);
      return;
    }
    if (
      formData.VenueOwnerReason === "5" &&
      formData.VenueOwnerReasonText === ""
    ) {
      setFormError({
        ...formError,
        errorId: 3,
        errorMsg: "Please enter specific reason.",
      });
      setFormLoader(false);
      return;
    }

    setFormError({ ...formError, errorId: 0, errorMsg: "" });
    var raw = JSON.stringify({
      Name: formData.VenueOwnerName,
      Email: formData.VenueOwnerEmail,
      PhoneNumber: parseInt(formData.VenueOwnerPhone),
      VenueName: VenueDetails.venueName,
      VenueId: VenueDetails.id,
      isClaimClick: isClaimClick ? true : false,
      notInterested: notInterested,
      message: formData?.VenueOwnerReasonText,
    });

    await CustomPostAPI("/venue/VenueOwnerClaimVenue", raw).then((result) => {
      if (result) {
        result = JSON.parse(result);
        if (result.status === "Success") {
          setFormData({
            ...formData,
            VenueOwnerName: "",
            VenueOwnerEmail: "",
            VenueOwnerPhone: "",
            VenueOwnerReason: "1",
            VenueOwnerReasonText: "",
          });
          setFormLoader(false);
          Swal.fire({
            title: "Request Sent Successfully",
            text: notInterested
              ? "Your request for not listing the venue has been sent to our admin. Our team will reach you out soon"
              : isClaimClick
              ? "Your request for claiming the venue has been sent to our admin. Our team will reach you out soon"
              : "Your request for changing the venue details has been sent to our admin. Our team will reach you out soon",
          });
          handlePopUp(0, false);
        } else {
          console.error("Something went wrong");
          setFormLoader(false);
        }
      }
    });
  };

  return (
    <div className="row">
      <div className="col-12 mb-3">
        <label htmlFor="name" className="w-100 Montserrat text-black fw-500">
          Name <small className="text-danger">*</small>
        </label>
        <input
          id="name"
          type="text"
          className="form-control custom-placeholder"
          autoComplete="off"
          value={formData.VenueOwnerName}
          onChange={(e) =>
            setFormData({ ...formData, VenueOwnerName: e.target.value })
          }
          placeholder="Enter your full name"
        />
        {formError.errorId === 1 && (
          <small className="text-danger">{formError.errorMsg}</small>
        )}
      </div>
      <div className="col-12 mb-3">
        <label htmlFor="email" className="w-100 Montserrat text-black fw-500">
          Email
        </label>
        <input
          id="email"
          type="email"
          className="form-control custom-placeholder"
          autocomplete="off"
          value={formData.VenueOwnerEmail}
          onChange={(e) =>
            setFormData({ ...formData, VenueOwnerEmail: e.target.value })
          }
          placeholder="Enter your email"
        />
      </div>
      <div className="col-12 mb-4">
        <label htmlFor="phoneno" className="w-100 Montserrat text-black fw-500">
          Phone <small className="text-danger">*</small>
        </label>
        <input
          id="phoneno"
          type="number"
          inputMode="numeric"
          className="form-control custom-placeholder"
          autocomplete="off"
          min={1}
          maxLength={10}
          value={formData.VenueOwnerPhone}
          onChange={(e) => {
            handlelength(e);
          }}
          placeholder="Enter your Phone no."
        />
        {formError.errorId === 2 && (
          <small className="text-danger">{formError.errorMsg}</small>
        )}
      </div>
      {notInterested && (
        <div className="col-12 mb-4">
          <label
            htmlFor="phoneno"
            className="w-100 Montserrat text-black fw-500"
          >
            Don’t want to list venue Let us know{" "}
            {/* <small className="text-danger">*</small> */}
          </label>
          <select
            className="form-select"
            id="playerroleid"
            aria-label=" select example"
            onChange={(e) => {
              const sel = e.target;
              setFormData({
                ...formData,
                VenueOwnerReason: e.target.value,
                VenueOwnerReasonText:
                  e.target.value !== "5"
                    ? sel.options[sel.selectedIndex].text
                    : "",
              });
            }}
            defaultValue={formData?.VenueOwnerReason}
          >
            <option value="1" className="txtGray">
              Managing on my own
            </option>
            <option value="2" className="txtGray">
              Not interested in any booking platform
            </option>
            <option value="3" className="txtGray">
              Already registered on another platform; don’t want a new one
            </option>
            <option value="4" className="txtGray">
              Under contract with other platform, intrested later
            </option>
            <option value="5" className="txtGray">
              Any other reason (please specify)
            </option>
          </select>
        </div>
      )}

      {formData.VenueOwnerReason === "5" && (
        <div className="col-12 mb-4">
          <label
            htmlFor="phoneno"
            className="w-100 Montserrat text-black fw-500"
          >
            Reason
            <small className="text-danger">*</small>
          </label>
          <textarea
            id="textarea"
            className="form-control custom-placeholder"
            autocomplete="off"
            value={formData.VenueOwnerReasonText}
            onChange={(e) =>
              setFormData({
                ...formData,
                VenueOwnerReasonText: e.target.value,
              })
            }
          ></textarea>

          {formError.errorId === 3 && (
            <small className="text-danger">{formError.errorMsg}</small>
          )}
        </div>
      )}
      <div className="d-flex justify-content-end claimNowDivModal">
        <button
          className="Montserrat fw-600"
          onClick={() => {
            setFormLoader(true);
            sendDetails();
          }}
        >
          {formLoader ? (
            <div
              class="spinner-border text-light spinner-border-sm"
              role="status"
            ></div>
          ) : (
            BtnText
          )}
        </button>
      </div>
    </div>
  );
}
